import CustomPlugin from "./CustomPlugin";
import ControlLayer from "../../components/custom/ControlLayer";
import SkyClickPlayer from "../../components/custom/SkyClickPlayer";

// This plugin add control layer div over play
// Used to add custom control element over video player
export default class ControlLayerPlugin extends CustomPlugin {

    static readonly PLUGIN_NAME = 'controlLayer';

    // activate autostart
    static autoStart = true;

    public controlLayerComponent: ControlLayer;

    init() {
        // PLUGIN CODE
        // console.log('Plugin "' + ControlLayerPlugin.PLUGIN_NAME + '" initalized ');
    }

    protected onPlayerReady(){
        // Add control layer component

        // Calculate child index, that control layer is behind big play button
        const bigPlayButtonIndex = this.skyClickPlayer.children().indexOf(this.skyClickPlayer.getChild('BigPlayButton'));
        // add control layer to player (before big play button component)
        this.controlLayerComponent = this.skyClickPlayer.addChild('ControlLayer',null,bigPlayButtonIndex) as ControlLayer;
    }

}

// *** extend player declaration with new plugin function

// interface, that base on plugin class with additional startup function declaration
interface WithStartupDeclaration extends ControlLayerPlugin{
    (options?: Object): ControlLayerPlugin
}
// Using of Type Scripts "Module Augmentation" https://www.typescriptlang.org/docs/handbook/declaration-merging.html#module-augmentation
// Extend VideoJSPlayer declaration with extend function by plugin
// So TypeScript compiler support the usage of this dynamic added function, because this plugin is added to the
declare global {
    interface VideoJSPlayer{
        controlLayer:WithStartupDeclaration
    }
}


// WEBPACK FOOTER //
// ./src/app/plugins/custom/ControlLayerPlugin.ts